import { render, staticRenderFns } from "./ServicesHeader.vue?vue&type=template&id=706d75cb"
import script from "./ServicesHeader.vue?vue&type=script&lang=js"
export * from "./ServicesHeader.vue?vue&type=script&lang=js"
import style0 from "./ServicesHeader.vue?vue&type=style&index=0&id=706d75cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports